import React, {useState} from 'react';
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const ApprehensionListContent = ({ data, boName }) => {
    const navigate = navigateHook();
    const apprehension_list = data?.apprehension_list ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = apprehension_list.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    return (
        <>
            <div className="mt-4 mb-3 table-div">
                <span className="table-title mb-2">Lista de apreensões {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>

                <table id="apprehension-list-data" className="table report-table mt-2" sheet-name={"Lista de apreensões"}>
                    <thead className="thead-background print:table-row-group!">
                        <tr className="text-left">
                            <th className="w-[7%]">{boName}</th>
                            <th className="w-[12%]">D/H do fato</th>
                            <th className="w-[65%]">Tipo de apreensão</th>
                            <th className="w-[31%]">Quantidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !apprehension_list?.length ? (
                            <NoDataRow colSpan={6} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? apprehension_list.slice(0, limit) : apprehension_list).map((element, index) => {
                            const url = `/bo/redirect/${element.id?.replace('/', '-')}`;

                            return (
                                <>
                                    <tr key={index}>
                                        <td className="w-[7%]"><a onClick={() => navigate(url, true)} className={'inner-link'}>{element.id ?? ""}</a></td>
                                        <td className="w-[12%]">{element.dt_fact ?? ""}</td>
                                        <td className="w-[65%]">{element.type ?? ""}</td>
                                        <td className="w-[31%]">{element.qty ?? ""}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default ApprehensionListContent;
